import moment from "moment";
import {
  IAppUsageReport,
  ICsvDownloadHeaders,
  IPerfImproveReport,
  IPerformanceReport,
  IProgressReport,
} from "./types";
import axios from "axios";
import { toast } from "react-toastify";
export const formatDataForCsv = (
  reportType:
    | "appUsage"
    | "contentProgress"
    | "performance"
    | "performanceImprovement",
  responseData: any
) => {
  let headers = [
    { label: "SRN Number", key: "srn_no" },
    { label: "First Name", key: "first_name" },
    { label: "Last Name", key: "last_name" },
    { label: "School Name", key: "school_name" },
    { label: "Grade", key: "grade" },
    { label: "Section", key: "section" },
    { label: "District", key: "district" },
    { label: "Block", key: "block" },
  ];
  let result: { headers: ICsvDownloadHeaders[]; data: any[] } = {
    headers: [],
    data: [],
  };

  if (reportType === "appUsage") {
    let data: IAppUsageReport[] = formatAppusageReport(responseData);
    headers.push({ label: "Avg. Usage (Hours : Minutes)", key: "usage_min" });
    result.headers = headers;
    result.data = data;
  } else if (reportType === "contentProgress") {
    let data: IProgressReport[] = formatContentProgressReport(responseData);
    headers.push(
      { label: "Total Material", key: "total_material" },
      { label: "Watched Material", key: "watched_material" },
      { label: "Material Consumption (%)", key: "material_consumption" },
      { label: "Time Spent (In Hours)", key: "time_spent" }
    );
    result.headers = headers;
    result.data = data;
  } else if (reportType === "performance") {
    let data: IPerformanceReport[] = formatPerformanceReport(responseData);
    headers.push(
      { label: "Points", key: "points" },
      { label: "Total Questions", key: "total_question" },
      { label: "Attempted Right", key: "attempted_right" },
      { label: "Attempted Wrong", key: "attempted_wrong" },
      { label: "Performance Score (%)", key: "performance_score" }
    );
    result.data = data;
    result.headers = headers;
  } else if (reportType === "performanceImprovement") {
    let data: IPerfImproveReport[] =
      formatPerformanceImprovementReport(responseData);
    headers.push(
      { label: "Current Points", key: "curr_points" },
      { label: "Current Attempted Right", key: "curr_attempted_right" },
      { label: "Current Attempted Wrong", key: "curr_attempted_wrong" },
      { label: "Current Performance (%)", key: "curr_performance_score" },
      { label: "Previous Points", key: "prev_tot_points" },
      { label: "Previous Attempted Right", key: "prev_attempted_right" },
      { label: "Previous Attempted Wrong", key: "prev_attempted_wrong" },
      { label: "Previous Performance (%)", key: "prev_performance_score" }
    );
    result.data = data;
    result.headers = headers;
  }
  return result;
};

const formatAppusageReport = (response: any[]) => {
  return response?.map((each: any) => ({
    srn_no: each?.srn_no || 0,
    first_name: each?.first_name || "Not Available",
    last_name: each?.last_name || "Not Available",
    school_name: each?.school || "Not Available",
    grade: each?.grade || "Not Available",
    section: each?.section || "Not Available",
    district: each?.district || "Not Available",
    block: each?.block || "Not Available",
    usage_min: each?.usage_min
      ? `${Math.floor(+each?.usage_min / 60)}:${+each?.usage_min % 60}`
      : "0",
  }));
};
const formatContentProgressReport = (response: any[]) => {
  return response?.map((each) => ({
    srn_no: each?.srn_no || 0,
    first_name: each?.first_name || "Not Available",
    last_name: each?.last_name || "Not Available",
    school_name: each?.school_name || "Not Available",
    grade: each?.grade || "Not Available",
    section: each?.section || "Not Available",
    district: each?.district || "Not Available",
    block: each?.block || "Not Available",
    total_material: each?.total_material || 0,
    watched_material: each?.watched_material || 0,
    material_consumption: Math.floor(each?.material_consumption) || 0,
    time_spent: `${Math.floor(+each?.time_spent / 60)}:${+each?.time_spent % 60
      }`,
  }));
};
const formatPerformanceReport = (response: any[]) => {
  return response?.map((each) => ({
    srn_no: each?.srn_no || 0,
    first_name: each?.first_name || "Not Available",
    last_name: each?.last_name || "Not Available",
    school_name: each?.school || "Not Available",
    grade: each?.grade || "Not Available",
    section: each?.section || "Not Available",
    district: each?.district || "Not Available",
    block: each?.block || "Not Available",
    points: each?.points || 0,
    total_question: each?.total_no_of_questions,
    attempted_right: each?.attempted_right || 0,
    attempted_wrong: each?.attempted_wrong || 0,
    performance_score: Math.round(each?.performance_score) || 0,
  }));
};
const formatPerformanceImprovementReport = (response: any[]) => {
  return response?.map((each) => ({
    srn_no: each?.srn_no || 0,
    first_name: each?.first_name || "Not Available",
    last_name: each?.last_name || "Not Available",
    school_name: each?.school || "Not Available",
    grade: each?.grade || "Not Available",
    section: each?.section || "Not Available",
    district: each?.district || "Not Available",
    block: each?.block || "Not Available",
    curr_points: each.curr_points ? each.curr_points : 0,
    curr_attempted_right: each?.curr_attempted_right,
    curr_attempted_wrong: each?.curr_attempted_wrong,
    curr_performance_score: Math.round(each?.curr_performance_score || 0),
    prev_tot_points: each?.prev_tot_points ? each?.prev_tot_points : 0,
    prev_attempted_right: each?.prev_attempted_right || 0,
    prev_attempted_wrong: each?.prev_attempted_wrong || 0,
    prev_performance_score: Math.round(each?.prev_performance_score || 0),
  }));
};

export const isValidDob = (dob: string) => {
  const date = dob.slice(0, 2);
  const month = dob.slice(3, 5);
  const year = Number(dob.slice(6));
  if (year < 1900) {
    return false;
  }
  return moment(`${year}-${month}-${date}`).isValid();
};


export const calculateDataUsingDivision = (
  divi: number,
  dividen: number
) => {
  const divisor: number = divi;
  const dividend: number = dividen;
  const result = (divisor / dividend * 100).toFixed(2) ?? 0;
  return result;
};

export const handleDownload = (fileUrl, title) => {
  // Replace with the URL of the downloadable file
  return new Promise((resolve, reject) => {
    axios({
      url: fileUrl,
      method: 'GET',
      responseType: 'blob', // Specify the response type as a blob
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = `${title.replaceAll("_", " ")}_${moment().format("DD-MM-YYYY")}.csv`; // Specify the filename
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        resolve(true);
      }).catch((error) => {
        console.error('Download failed with error: ', error?.response);
        // toast.error(error?.message || "Failed to download the report");
        reject(error);
      });
  })
}